var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19708 10.6653L6.21768 10.7026C7.30645 11.8119 8.82287 12.5 10.5 12.5C13.2958 12.5 15.6449 10.5878 16.311 8H18C20.2091 8 22 9.79086 22 12V21C22 21.5523 21.5523 22 21 22H18C17.4477 22 17 21.5523 17 21V19C17 18.4477 16.5523 18 16 18H13C12.4477 18 12 18.4477 12 19V21C12 21.5523 11.5523 22 11 22H8C7.44772 22 7 21.5523 7 21V14H5V18C5 18.5523 4.55228 19 4 19H3C2.44772 19 2 18.5523 2 18V7H2.02746C2.00932 6.83583 2 6.669 2 6.5C2 4.01472 4.01472 2 6.5 2C7.21842 2 7.89752 2.16835 8.5 2.46776C8.68774 2.37446 8.88291 2.29389 9.0844 2.22717C9.25132 2.1719 9.42257 2.12614 9.59752 2.09052C9.88909 2.03116 10.1909 2 10.5 2C12.9853 2 15 4.01472 15 6.5C15 7.00482 14.9169 7.49023 14.7636 7.94328C14.7572 7.96224 14.7506 7.98115 14.7439 8C14.1262 9.74779 12.4593 11 10.5 11C9.20865 11 8.04434 10.4561 7.2237 9.58479C6.53737 9.24998 5.82761 9.99701 6.19708 10.6653ZM5.75 7.5C6.16421 7.5 6.5 7.16421 6.5 6.75C6.5 6.33579 6.16421 6 5.75 6C5.33579 6 5 6.33579 5 6.75C5 7.16421 5.33579 7.5 5.75 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.1646b617145ba3391953b83ec66ecbb8.svg";
export { ForwardRef as ReactComponent };